
var successClass = 'positive';
var failureClass = 'negative';

var ACTION_READY   = 'ready';
var ACTION_CANCEL  = 'cancel';
var ACTION_NEUTRAL = 'neutral';

var iconNeutral = 'arrow-right';
var iconCancel  = 'arrow-left';
var iconSuccess = 'check';



//
// Modal Action Button
//

module.exports = function ModalActionButton ($host, config) {

  // Setup
  var endpoint = config.endpoint;

  // Dom
  var $icon = $('[data-icon]',        $host);
  var $text = $('[data-button-text]', $host);

  // State
  var state     = { mode: ACTION_NEUTRAL };
  var callbacks = { success: id, failure: id, readyClick: id, cancelClick: id };

  // Functions
  function submit (data) {
    setBusy();

    log('ModalActionButton::submit', data);

    $.ajax({
      url: endpoint,
      data: data,
      type: 'get',
      dataType: 'json',
      error: onError,
      success: function (res) {
        if (res.is_error) {
          onError(res.reason);
        } else {
          onSuccess(res.value);
        }
      }
    });
  }

  function onSuccess (response) {
    callbacks.success(response);
    $text.text(config.successText);
    $icon.attr('data-icon', iconSuccess);
  }

  function onError (reason) {
    callbacks.failure(reason);
    console.warn("ModalActionButton::onError", reason, reason.responseText);
    setMode(ACTION_CANCEL, reason);
  }

  function setBusy (text) {
    text = text || "";
    $text.text(text);
    $icon.attr('data-icon', 'busy');
  }

  function handleAction () {
    switch (state.mode) {
      case ACTION_CANCEL:
        callbacks.cancelClick();
        break;

      case ACTION_READY:
        callbacks.readyClick();
        break;
    }
  }

  function setMode (mode, text) {
    state.mode = mode;
    $host.removeClass(successClass + " " + failureClass);

    switch (mode) {
      case ACTION_NEUTRAL:
        $host.attr('disabled', true);
        $text.text(text || config.neutralText);
        $icon.attr('data-icon', iconNeutral);
        break;

      case ACTION_CANCEL:
        if (!text) { console.warn('setMode: text required for ACTION_CANCEL'); }
        $host.attr('disabled', null);
        $host.addClass(failureClass);
        $text.text(text || "No error text specified");
        $icon.attr('data-icon', iconCancel);
        break;

      case ACTION_READY:
        $host.attr('disabled', null);
        $host.addClass(successClass);
        $text.text(text || config.readyText);
        break;
    }
  }

  // Listeners
  $host.on('click', handleAction);

  // Interface
  return {
    submit:  submit,
    setMode: setMode,
    onSuccess:     function (λ) { callbacks.success     = λ; },
    onFailure:     function (λ) { callbacks.failure     = λ; },
    onReadyClick:  function (λ) { callbacks.readyClick  = λ; },
    onCancelClick: function (λ) { callbacks.cancelClick = λ; },
  }

}


// Static external reference

module.exports.ACTION_READY   = ACTION_READY;
module.exports.ACTION_NEUTRAL = ACTION_NEUTRAL;
module.exports.ACTION_CANCEL  = ACTION_CANCEL;


